export default [
    {
        idDrink: "4.4",
        strDrink: "Foxtail", 
        strDrinkThumb:"/images/foxtail-drink.jpg",
        strAlcoholic: "Alcoholic",
        strGlass: "Coupe Glass is needed",
        strIngredient1: "Gin",
        strIngredient2: "Grapefriut Juice",
        strIngredient3: "Benedictine",
        strIngredient4: "Grapefriut Peel",
        strIngredient5: "small edible fox  and tree sculptures (optional)",
        strInstructions:"Fill a shaker with ice cube. Add gin, grapefruit juice, and benedictine to the shaker and shake well. Strain the mixture into a cocktail glass. Twist a grapefruit peel over the drink and drop it in. If you have a fox and tree sculptures , place it on top of the drink carefully.",
        strMeasure1: "1 oz",
        strMeasure2: "1 oz",
        strMeasure3: "1 oz",
        strMeasure4: "1 twist",
        strMeasure5: "",

    }
]